import { render, staticRenderFns } from "./HighlightDownloadDialog.vue?vue&type=template&id=0585a5d7"
import script from "./HighlightDownloadDialog.vue?vue&type=script&lang=js"
export * from "./HighlightDownloadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports